import React, { useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

var items = [
    {
        title: 'Qu’est ce que l’Avance Immédiate ?',
        body: 'L’Avance Immédiate est un service gratuit proposé par l’URSSAF.\nVous bénéficiez d’un crédit d’impôt de 50 % pour toutes vos activités de service à la personne.\nEn clair, vous ne faites plus d’avance de trésorerie. Vous bénéficiez de votre crédit d’impôt au moment de la dépense, sans attendre l’année suivante !\nhttps://www.urssaf.fr/accueil/services/services-particuliers/service-avance-immediate.html'
    },
    {
        title: 'Pourquoi créer un compte URSSAF ?',
        body: 'La création de ce compte est nécessaire afin de bénéficier de votre crédit d’impot de 50 % sur vos séances de coaching Hoplà Coaching.'
    },
    {
        title: 'J’ai déjà un compte URSSAF pourquoi en créer un autre ?',
        body: 'La création du compte URSSAF depuis notre site nous permet de nous mettre en lien direct avec l’ Avance Immédiate.'
    },
    {
        title: 'Est ce que je peux payer en espèces ?',
        body: 'Non, vous êtes prélevé par l’URSSAF directement.'
    },
    {
        title: 'Est ce que je peux annuler ma séance ?',
        body: 'Oui, vous pouvez annuler la séance dans votre espace « Mon profil »'
    },
    {
        title: 'Est ce que je dois acheter du matériel ?',
        body: 'Il n’est pas nécessaire d’acheter du matériel pour vos séances, votre coach sportif vous le fournira.'
    }
];

interface FaqProps {
    pattern?: string;
}

const Faq: React.FC<FaqProps> = ({ pattern }) => {
    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange = (panel: string) => (
        event: React.SyntheticEvent,
        isExpanded: boolean
    ) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box width="100%" margin="auto">
            {items.filter(item => pattern ? item.body.includes(pattern) || item.title.includes(pattern) : true).map((item, index) => (
                <Accordion
                    key={index}
                    expanded={expanded === `panel${index}`}
                    onChange={handleChange(`panel${index}`)}
                    sx={{
                        padding: 0,
                        boxShadow: "none",
                        "&:before": { display: "none" },
                    }}
                >
                    <AccordionSummary
                        expandIcon={
                            <ExpandMoreIcon />
                        }
                        sx={{
                            minHeight: "50px",
                            display: "flex",
                            alignItems: "center",
                            padding: 0
                        }}
                    >
                        <Typography fontWeight='600' fontSize='clamp(1rem, 1.3vmax, 1.3vmax)' variant="body2" sx={{ flexGrow: 1, margin: "0px" }}>
                            {item.title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ padding: 0 }}>
                        <Typography fontSize='clamp(1rem, 1.3vmax, 1.3vmax)' sx={{ whiteSpace: 'pre-line', margin: "0px" }}>{item.body}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default Faq;
